import { getFrameioErrorCode, getFrameioErrorKey } from '@/lib/frameio/errors';
import { getMediasiloErrorCode, getMediasiloErrorKey } from '@/lib/mediasilo/errors';

// Frame.io shares and MediaSilo reviews are both "share imports": a link that
// lists a folder of videos, from which the user picks several and one
// project/library is created per video. They share the picker and batch flow;
// only copy (i18n namespace) and error codes differ.
export type ShareImportPlatform = 'frameio' | 'mediasilo';

export function isShareImportPlatform(platform: unknown): platform is ShareImportPlatform {
  return platform === 'frameio' || platform === 'mediasilo';
}

/** i18n namespace holding the provider's picker/summary/error copy. */
export function shareImportCopyNamespace(platform: ShareImportPlatform): ShareImportPlatform {
  return platform;
}

export function getShareImportErrorKey(error: unknown, platform: ShareImportPlatform = 'frameio'): string {
  if (getMediasiloErrorCode(error)) return getMediasiloErrorKey(error);
  if (getFrameioErrorCode(error)) return getFrameioErrorKey(error);
  return platform === 'mediasilo' ? getMediasiloErrorKey(error) : getFrameioErrorKey(error);
}

export function isShareImportProRequired(error: unknown): boolean {
  return getFrameioErrorCode(error) === 'FRAMEIO_PRO_REQUIRED'
    || getMediasiloErrorCode(error) === 'MEDIASILO_PRO_REQUIRED';
}
